// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1Nk4J","title":"ClientInsurance_title__2tRvM","itemText":"ClientInsurance_itemText__1yMaz"};